export interface Price {
  id: number;
  product_id: number;
  type: PRICE_TYPE;
  sequence: string;
  multiplier: number;
  unit: string;
  currency_code: string | null;
  customer_id: number | null;
  value: number;
}

export enum PRICE_TYPE {
  STANDARD = 'standard',
  SEQUENTIAL = 'sequential',
  CUSTOM = 'custom'
}
